import React, { useRef, useState } from "react";
import "./InviteUserDialog.scss";
import axios from "../../utils/axios";
import BaseDialog from "../../modelDialogs/BaseDialog";
import ProjectMetadata, { UserReference } from "../../models/ProjectMetadata";
import ConfirmDialog from "../../modelDialogs/ConfirmDialog";

import { inviteOneUser } from "../../services/projectUsers";
import { itx } from "../../translationItx/itx";

const pendingInvitedUsersByProject = new Map<string, Array<string>>();

export default function InviteUserDialog(props: { project: ProjectMetadata; alreadyInvitedUsers: Array<string> }) {
  const { project, alreadyInvitedUsers: newInvitedUsers } = props;
  const projectId = project?.id || "";

  function cleanupPendingUsers(inputPendingUsers: Array<string>) {
    const existingUserEmails = new Set((project?.users || []).map((user) => (user.email || "").toLowerCase()));
    return inputPendingUsers.filter((pendingEmail) => !existingUserEmails.has((pendingEmail || "").toLowerCase()));
  }

  function getInitialPendingUsers() {
    const persisted = pendingInvitedUsersByProject.get(projectId) || [];
    const merged = [...persisted];
    newInvitedUsers.forEach((userEmail) => {
      if (!merged.includes(userEmail)) {
        merged.push(userEmail);
      }
    });
    const cleaned = cleanupPendingUsers(merged);
    if (projectId) {
      pendingInvitedUsersByProject.set(projectId, cleaned);
    }
    return cleaned;
  }

  function savePendingUsersForProject(pendingUsers: Array<string>) {
    const cleaned = cleanupPendingUsers(pendingUsers);
    if (projectId) {
      pendingInvitedUsersByProject.set(projectId, cleaned);
    }
    return cleaned;
  }

  const [pendingInvitedUsers, setPendingInvitedUsers] = useState<Array<string>>(() => getInitialPendingUsers());

  const invitedUsers = project?.users || new Array<UserReference>();
  const emailElm = useRef<HTMLInputElement>(null);

  const email = useRef<string>("");
  const invitationRunning = useRef(false);
  const [inviting, setInviting] = useState(false);

  const style1 = { paddingLeft: "5px", paddingTop: "5px" };

  function CurrentUserDisplay(props: {}) {
    const {} = props;
    const currentUsers: any = [];
    let userCurrentLoggedIn = false;
    let isAdminUser = false;
    invitedUsers.forEach((user) => {
      if (user.id && user.id != "" && user.email == state.loggedInUser.email) {
        isAdminUser = true;
      }
    });
    const adminUser = invitedUsers[0];

    invitedUsers.forEach((user) => {
      if (user.email == state.loggedInUser.email) {
        userCurrentLoggedIn = true;
      }

      // TODO: MWE 25.4.2023 Admin User für ein Project bestimmen

      currentUsers.push(
        <tr key={user.email?.toLowerCase() || user.id} style={{ height: "40px" }}>
          {/* <td style={{ paddingLeft: "0" }}>
            {userCurrentLoggedIn && (
              <i className="las la-user" style={{ width: "max-content" }} />
            )}
          </td> */}

          <td style={{ verticalAlign: "middle" }}>
            {isAdminUser && (
              <div
                style={{ paddingLeft: "10px" }}
                data-tooltip-id="tv-tooltip"
                data-tooltip-content={
                  userCurrentLoggedIn
                    ? state.translate("inviteUserDialog.ownEmail", "own E-Mail")
                    : state.translate("inviteUserDialog.deleteUser", "Mitarbeiter entfernen")
                }
                data-tooltip-place="left" // no itx
              >
                <button
                  className="button"
                  style={{
                    width: "30px",
                    height: "30px",
                    textAlign: "center",
                    padding: "0px",
                  }}
                  onClick={() => deleteInvitedUser(user.email)}
                  disabled={userCurrentLoggedIn}
                >
                  <i
                    style={{
                      height: "14px",
                      color: "var(--defaultActiveColor)",
                    }}
                    className={userCurrentLoggedIn ? "las la-user" : `las la-trash`} // no itx
                  />
                </button>
              </div>
            )}
          </td>
          <td
            style={{
              paddingLeft: "10px",
              verticalAlign: "middle",
            }}
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={user.id == adminUser.id ? itx("InviteUserDialog.isAdminUser", "ist Admin User") : ""}
            data-tooltip-place="right"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>{user.email}</div>
              {user.id == adminUser.id && (
                <div style={{ marginLeft: "5px", fontSize: "9px", color: "var(--defaultActiveColor)" }}>
                  <i className="las la-star" />
                </div>
              )}
            </div>
          </td>
        </tr>,
      );
      userCurrentLoggedIn = false;
    });

    async function deleteInvitedUser(email: string) {
      state.dialogManager.openDialog(
        <ConfirmDialog
          className="dialog-standard"
          title={state.translate("inviteUserDialog.userDelete", `User Delete`)}
          text={state.translate(
            "inviteUserDialog.removeT1fromProjectT2",
            `You want to remove this user: ${email} from project: ${project.name}`,
            {
              T1: email,
              T2: project.name,
            },
          )}
          onOk={() => {
            // remove user from project
            const payload = {
              emailOfFriend: email?.toLowerCase(),
              projectId: project.id,
            };
            axios
              .delete("/api/project/invite/user", {
                data: payload,
              })
              .then((result) => {
                if (result.data.STATUS === "SUCCESS") {
                  // setInvitedUsers(
                  //  , project.users.filter(
                  //     (user: { email: string }) => user.email !== email,
                  //   )
                  // );
                  // saved Project with old data-> remove user manuel
                  const newUsers = project.users.filter((user: { email: string }) => user.email !== email);
                  project.users = newUsers;
                  state.allProjectsMap.set(project.id, project);

                  state.dialogManager.openDialog(
                    <BaseDialog
                      title={state.translate("Success", "Success")}
                      onOk={() => {
                        state.dialogManager.openDialog(
                          <InviteUserDialog project={project} alreadyInvitedUsers={newInvitedUsers} />,
                        );
                        return false;
                      }}
                      okCaption={state.translate("ok", "Ok")}
                      noAbortButton={true}
                    >
                      <div style={{ padding: "20px" }}>{result.data.MESSAGE}</div>
                    </BaseDialog>,
                  );
                } else {
                  state.dialogManager.openDialog(
                    <BaseDialog
                      title={state.translate("error", "Error")}
                      onOk={() => {
                        state.dialogManager.openDialog(
                          <InviteUserDialog project={project} alreadyInvitedUsers={newInvitedUsers} />,
                        );
                        return false;
                      }}
                      okCaption={state.translate("ok", "Ok")}
                      noAbortButton={true}
                    >
                      <div style={{ padding: "20px" }}>
                        {state.translate("setPassword.somthingWentwrong", "Something Went wrong.")}
                      </div>
                    </BaseDialog>,
                  );
                }
              })
              .catch(() => {
                state.dialogManager.openDialog(
                  <BaseDialog
                    title={state.translate("error", "Error")}
                    onOk={() => {
                      state.dialogManager.openDialog(
                        <InviteUserDialog project={project} alreadyInvitedUsers={newInvitedUsers} />,
                      );
                      return false;
                    }}
                    okCaption={state.translate("ok", "Ok")}
                    noAbortButton={true}
                  >
                    <div style={{ padding: "20px" }}>
                      {state.translate("setPassword.somthingWentwrong", "Something Went wrong.")}
                    </div>
                  </BaseDialog>,
                );
              });
            return true;
          }}
          onClose={() => {
            return true;
          }}
          hideXButton={true}
        />,
      );
    }

    return (
      <div>
        {" "}
        <div style={{ paddingLeft: "20px", textAlign: "center" }}>
          <b>{state.translate("inviteUserDialog.currentUser", "Aktuelle Mitarbeiter")}</b>
        </div>
        <div style={style1}>
          <table>
            <tbody>{currentUsers}</tbody>
          </table>
        </div>
        <br />
      </div>
    );
  }
  function NewInvitedUsersDisplay(props: {}) {
    const listOfUsers = new Array<any>();
    let i = 0;
    pendingInvitedUsers.forEach((user: string) => {
      listOfUsers.push(
        <div key={i} style={{ minHeight: "40px", paddingLeft: "30px", display: "flex", alignItems: "center" }}>
          {user}
        </div>,
      );
      i++;
    });
    if (listOfUsers.length == 0) {
      return null;
    }

    return (
      <div>
        <div style={{ paddingLeft: "20px", textAlign: "center" }}>
          <b>
            {listOfUsers.length == 0
              ? state.translate("inviteUserDialog.noInvitedUsers", "Keine ausstehenden Einladungen")
              : state.translate("inviteUserDialog.invitedUsers", "Ausstehende Einladungen")}
          </b>
        </div>
        {listOfUsers.length > 0 && <div style={style1}>{listOfUsers}</div>}
      </div>
    );
  }

  function InviteUserDisplay(props: {}) {
    const {} = props;
    async function inviteOneUserFromDialog() {
      if (invitationRunning.current) return;
      invitationRunning.current = true;
      setInviting(true);
      const emailInvited = email.current;
      let result;
      try {
        result = await inviteOneUser({ project, email: emailInvited, currentUsers: invitedUsers });
      } finally {
        invitationRunning.current = false;
        setInviting(false);
      }

      if (result.status == "SUCCESS") {
        state.dialogManager.openDialog(
          <BaseDialog
            title={state.translate("inviteUserDialog.inviteSend", "Eine Einladung wurde versendet")}
            onOk={() => {
              let nextPendingInvitedUsers = pendingInvitedUsers;
              if (!nextPendingInvitedUsers.includes(emailInvited)) {
                nextPendingInvitedUsers = [...nextPendingInvitedUsers, emailInvited];
              }
              nextPendingInvitedUsers = savePendingUsersForProject(nextPendingInvitedUsers);
              setPendingInvitedUsers(nextPendingInvitedUsers);
              state.dialogManager.openDialog(
                <InviteUserDialog project={project} alreadyInvitedUsers={nextPendingInvitedUsers} />,
              );
              return false;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{result.message}</div>
          </BaseDialog>,
        );
        email.current = "";
        if (emailElm.current) {
          emailElm.current.value = "";
        }
      } else if (result.code == "ALREADY_USER") {
        state.dialogManager.openDialog(
          <BaseDialog
            title={state.translate(
              "inviteUserDialog.personAlreadyExisting",
              "Sie haben eine schon vorhandenen Person eingeladen",
            )}
            onOk={() => {
              state.dialogManager.openDialog(
                <InviteUserDialog project={project} alreadyInvitedUsers={newInvitedUsers} />,
              );
              return false;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{result.message},</div>
          </BaseDialog>,
        );
      } else {
        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={result.code === "METADATA_SAVE_FAILED"
              ? state.translate("inviteUserDialog.metadataSaveFailedTitle", "Projektmitarbeiter nicht gespeichert")
              : state.translate("inviteUserDialog.inviteSendNotPossible", "Die Einladung konnte nicht versendet werden")}
            onOk={() => {
              state.dialogManager.openDialog(
                <InviteUserDialog project={project} alreadyInvitedUsers={newInvitedUsers} />,
              );
              return false;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{result.message}</div>
          </BaseDialog>,
        );
      }
    }
    return (
      <div>
        <div style={{ paddingLeft: "20px", textAlign: "center" }}>
          <b>{state.translate("inviteUserDialog.userInvite", "Mitarbeiter einladen")}</b>
        </div>

        <div style={style1}>
          {state.translate(
            "inviteUserDialog.giveAccessToOtherUsers",
            "Gebe weiteren Personen Zugriff auf das Projekt ",
          )}
          <br />
          {state.translate("inviteUserDialog.throuthInviteMail", "durch eine Einladungs-Email. ")}
          <br />
          <br />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <input
              className="input"
              placeholder={state.translate(
                "inviteUserDialog.emailAdressOfUser",
                "E-Mail Adresse des/r Mitarbeiters/in",
              )}
              ref={emailElm}
              style={{ width: "100%" }}
              id="email"
              type="email"
              maxLength={state.maxCharLimit.text}
              onChange={(ev) => {
                email.current = ev.target.value.trim();
              }}
            />
          </div>
          <div
            style={{
              textAlign: "center",
              paddingTop: "10px",
            }}
          >
            <button
              className="button"
              disabled={inviting}
              onClick={() => {
                inviteOneUserFromDialog();
              }}
            >
              {state.translate("inviteUserDialog.invite", "Einladen")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <BaseDialog
      className="InviteUserDialog"
      title={project.name + state.translate("inviteUserDialog.inviteUser", ": Lade Mitarbeiter ein")}
      noAbortButton={true}
      okCaption={state.translate("inviteUserDialog.finished", "Fertig")}
      onOk={() => {
        // const back=await inviteOneUser()
        return true;
      }}
    >
      <div className="actList">
        <CurrentUserDisplay />
        <NewInvitedUsersDisplay />
        <InviteUserDisplay />
      </div>
    </BaseDialog>
  );
}
